/* unplugin-vue-components disabled */import { render } from "./BaseLayout.vue?vue&type=template&id=6ff8394a&scoped=true&ts=true"
import script from "./BaseLayout.vue?vue&type=script&lang=ts"
export * from "./BaseLayout.vue?vue&type=script&lang=ts"

import "./BaseLayout.vue?vue&type=style&index=0&id=6ff8394a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff8394a"]])

export default __exports__